import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Footer component
 * @returns {JSX.Element} Footer component
 */
const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 2,
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '0.875rem',
        color: 'text.secondary',
        width: '100%'
      }}
    >
      <Typography variant="body2">
        © {new Date().getFullYear()} HighQ Metrics Portal
      </Typography>
    </Box>
  );
};

export default Footer;
